<template>
  <IntroArticle :group-menu="useNavMenuItem(3)" />
</template>

<script lang="ts" setup></script>
